import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="lg-hub" x1="0" y1="0" x2="40" y2="40">
        <stop offset="0%" stopColor="#00F0FF" />
        <stop offset="100%" stopColor="#0070F3" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="36" height="36" rx="10" fill="#0B0F19" stroke="url(#lg-hub)" strokeWidth="1.5" />
    <path d="M15 12L27 20L15 28V12Z" fill="url(#lg-hub)" />
    <path d="M29 14V10H33V30H29V26" stroke="#00F0FF" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function Logo({ to = "/" }) {
  return (
    <Link to={to} data-testid="logo-link" className="flex items-center gap-2.5 group shrink-0">
      <LogoMark className="h-9 w-9 transition-all duration-300 group-hover:drop-shadow-[0_0_12px_rgba(0,240,255,0.7)]" />
      <span className="font-display font-extrabold tracking-tight text-lg text-slate-900">
        IPTV<span className="text-electric">HUB</span>
      </span>
    </Link>
  );
}
